export default __webpack_public_path__ + "static/media/ts2.f4503135.png";